<template>
  <div class="code" @click="setTime" :class="lightCode ? 'blue_active' : ''">
    <span>
      <span v-if="language == 'zh-hk' || language == 'zh-cn'">{{ count }}</span>
      <span v-show="!open">{{ lang.after60Lang }}</span>
      <span v-if="language == 'en-us'">{{ count }}<i v-show="!open">s</i></span>
    </span>
  </div>
</template>

<script>
import pub from '../../../common/public';
import lang from '../../../common/language/new_login';
export default {
  props: {
    userInput: {
      type: Object,
      default: ''
    }
  },
  created() {
    this.language = pub.getLang();
  },
  data() {
    return {
      language: 'zh-hk',
      lang: lang,
      num: 60,
      count: lang.getCodeLang,
      timer: null,
      open: true,
      lightCode: false, //控制高亮
      error: ''
    };
  },
  methods: {
    /* 点击验证码 */
    setTime() {
      let { telephone, check } = this.userInput;
      if (!telephone || /\D/.test(telephone)) return;
      console.log(111);
      this.$emit('click', this.error);
      if (this.lightCode) {
        if (this.open) {
          this.sendCodeApi(telephone, check).then(res => {
            if (res.data.code == 0) {
              this.open = false;
              this.count = this.num;
              console.log('短信发送');
              this.timer = setInterval(() => {
                this.count = --this.count;
                if (this.count == 0) {
                  // this.$emit('end', true);
                  this.open = true;
                  clearInterval(this.timer);
                  this.count = this.lang.getCodeLang;
                }
              }, 1000);
            } else if (res.data.code == 104) {
              this.error = this.lang.codeNumLang;
              this.$emit('end', this.error);
            } else {
              this.error = this.lang.NoInterNetLang;
              this.$emit('end', this.error);
            }
          });
        }
      }
    },
    /* 发送验证码API */
    sendCodeApi(telephone, check = '852') {
      let res = this.axios.post(pub.getApi().SendCaptcha, {
        phoneCode: check,
        phone: telephone
      });
      return res;
    }
  },
  watch: {
    'userInput.telephone'(value) {
      let result = this.pub.telValidator(value);
      switch (result) {
        case 0:
          this.error = '';
          break;
        case 1:
          this.error = this.lang.errTelLang;
          break;
        case 2:
          this.error = this.lang.errTelFormLang;
          break;
      }

      if (result == 0) {
        this.lightCode = true;
      } else {
        this.lightCode = false;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.code {
  cursor: pointer;
  // width: 100px;
  margin-left: 8px;
  text-align: center;
  .blue_active {
    color: #0076ff;
  }
}
</style>
